var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiAlert',{attrs:{"content":"Strona wymaga autoryzacji. Zaloguj się aby kontynuować.","closable":false,"theme":"warning"}})}
var staticRenderFns = []

export { render, staticRenderFns }